/* eslint-disable */
import Vue from 'vue';
import CustomToolbar from './edu-toolbar.vue';
import { getEduMenu } from '../../utils/api'

const render = (props) => {
  new Vue({
    el: '#CustomToolbarItem',
    render: h => h(CustomToolbar, {
      props: {
        ...props
      }
    }),
  });
};
const createDom = (props) => {
  $('.toolbar-btn-collect, .toolbar-btn-dynamic, .toolbar-btn-write, .toolbar-btn-vip').hide();
  const cardStr = `<div class="toolbar-btn csdn-toolbar-fl"><div id="CustomToolbarItem"></div></div>`;
  $('#csdn-toolbar .toolbar-btns')
    .append(cardStr)

  setTimeout(() => {
    render(props);
  })
};
const renderToolBarMenusDom = (arr = []) => {
  try {
    const domData = arr.slice();
    let aTagArray = '';
    for (let index = 0; index < domData.length; index++) {
      // ${domData[index].spm}
      aTagArray += `
        <a class='${domData[index].className || "custom_toolbar_content_nomoral"}'
          href='${domData[index].url}'
          title="${domData[index].desc}"
          target="${domData[index].is_new ? '_blank' : '_self'}"
          style="position:relative;"
          ${domData[index].spm ? 'data-report-click=' + JSON.stringify({spm: domData[index].spm}) + " data-report-query='spm=" + domData[index].spm + "'" : ''}
        >
          <span style='vertical-align: middle;'>${domData[index].title}</span>
          ${ domData[index].icon ? "<img src='" + domData[index].icon + "'style='width:14px;height:14px;position:absolute;top:8px;' />" : '' }
        </a>
      `;
    }
    return aTagArray;
  } catch (error) {
    return '';
  }
};

export const customToolbar = {
  name: 'CustomToolbar',
  data() {
    return {
      customToolbar: [],
      toolbarMenusConfig: [],
      hasCreated: false,
      extra: [],
    };
  },
  mounted() {
    this.remodelToolbar()
  },
  methods: {
    remodelToolbar() {
      window.csdn.toolbarFinishCallback = this.createCommonMenu;
      setTimeout(()=>{
        window.csdn.toolbarFinishCallback()
      },1000)
    },
    getToolbarConfig() {
      return new Promise((resolve, reject) => {
        const paramsObj = {
          // pc端配置
          alias: 'pc_index',
        };
        getEduMenu(paramsObj)
        .then(res => {
          if(res.code === 200) {
            const {ext} = res.data || {ext: "{}"};
            const configObj = JSON.parse(ext);

            this.toolbarMenusConfig = configObj.nav || [];
            this.extra = configObj.extra || [];
            resolve(configObj.nav || []);
          } else {
            console.error('获取toolbar配置出错', res.code, res.msg);
            this.toolbarMenusConfig = [];
            reject();
          }
        })
        .catch(err => {
          console.error('解析toolbarconfig json出错', err);
        });
      });
    },
    async createCommonMenu() {
      if(this.hasCreated) return
      this.hasCreated = true ;

      let res = await this.getToolbarConfig();
      createDom({extra: this.extra});
      const path = window.location.pathname;
      const index = res.findIndex((v) => v.url.includes(path));
      if (index > -1 && path !== '/') {
        res = res.map((v) => {
          v.className = 'custom_toolbar_content_nomoral';
          return v;
        });
        res[index].className = 'custom_toolbar_content_active';
      }
      this.customToolbar = res;
      this.setToolbar();
      // window.csdn.isToolbarFinished = true;
      return res;
    },
    setToolbar() {
      const leftMenu = `
        <div class="toolbar-menus csdn-toolbar-fl">
          <div>${renderToolBarMenusDom(this.customToolbar)}</div>
        </div>`;
      $('.toolbar-container-left').append(leftMenu);
      // if (!window.csdn.isToolbarFinished) {
        window.csdn.toolbar.renderSeasrchBox('.toolbar-container-mini-middle');
      // }
      $('.toolbar-btns');
      $('.toolbar-container-mini-middle').css({
        'max-width': '720px',
        'min-width': '335px',
      });
    },
  },
};
